import { atom } from 'jotai';
import { TComment } from 'shared/models';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

type TArticleImmersiveRelatedPostFirstCommentsStore = { [key: string]: Promise<TComment[]> | TComment[] | undefined };

const $ArticleImmersiveRelatedPostFirstCommentsStore = atom<TArticleImmersiveRelatedPostFirstCommentsStore>({});

export const $ArticleImmersiveRelatedPostFirstComments = safeAtomFamily((groupId: string) => {
  const a = atom(
    (get) => {
      const data = get($ArticleImmersiveRelatedPostFirstCommentsStore)[groupId];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, input: TComment[] | Promise<TComment[]>) => {
      const old = get($ArticleImmersiveRelatedPostFirstCommentsStore);
      set($ArticleImmersiveRelatedPostFirstCommentsStore, {
        ...old,
        [groupId]: input,
      });
    },
  );

  a.debugLabel = `$ArticleImmersiveRelatedPostFirstComments+${encodeURIComponent(groupId)}`;

  return a;
});
